import axios from 'axios';
import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import extend from 'lodash/extend';
import authUtil from '../utils/auth_util';
import log from '../services/logger_service';

export default class Newsletter {
  post(args, config) {
    const { url, options } = this.buildRequestObj(args, config, 'post');

    return axios.post(url, options);
  }

  put(args, config) {
    const { url, options } = this.buildRequestObj(args, config, 'put');
    return axios.post(url, options);
  }

  buildRequestObj(args, config, method) {
    const host = get(config, 'apiEndpoint');
    const protocol = get(config, 'protocol');
    const options = extend({}, args);
    const base = `${protocol}${host}/api/v2/newsletter`;

    const urls = {
      post: base,
      put: `${base}-email`
    };

    // api has auth in beta
    if (get(config, 'authEnabled')) {
      extend(options, authUtil(config, 'post'));
    }
    const url = urls[method];
    if (!canUseDOM) {
      log.info(`Requesting: ${url} from model.`);
    }

    return { url, options };
  }
}
